import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const accountApi = axios.create({ baseURL: API, withCredentials: true });

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = signed in

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — the callback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return setUser(false);
    try {
      const { data } = await accountApi.get("/account/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await accountApi.post("/account/login", { email, password });
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (name, email, password) => {
    const { data } = await accountApi.post("/account/register", { name, email, password });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await accountApi.post("/account/logout"); } catch { /* noop */ }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, register, logout, refresh }), [user, login, register, logout, refresh]);
  return <CustomerAuthContext.Provider value={value}>{children}</CustomerAuthContext.Provider>;
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
